const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

//Obtaind online
const PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='500'%3E%3Crect width='100%25' height='100%25' fill='%23eef2ff'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%2364748b' font-family='Arial' font-size='26'%3ENo Image%3C/text%3E%3C/svg%3E";

/**
 * Convert stored image path into a browser-usable URL.
 * So images can take the following directory pattern:
 * - data URLs
 * - full URLs
 * - backend uploads: /uploads/xxx or uploads/xxx
 * - plain file name -> assume it lives in backend /uploads
 */
export function imgSrc(imagePath) {
  const s = String(imagePath || "").trim();
  if (!s) return PLACEHOLDER;
  if (s.startsWith("data:")) return s;
  if (s.startsWith("http://") || s.startsWith("https://")) return s;

  if (s.startsWith("/uploads/")) return `${API_URL}${s}`;
  if (s.startsWith("uploads/")) return `${API_URL}/${s}`;

  if (s.startsWith("/")) return s;

  return `${API_URL}/uploads/${s}`;
}
